import classes from "./SortByFilter.module.less";
import { MenuItem, Select } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { MediaFormFields } from "~/MediaLibrary/types/mediaLibraryFormTypes";

export default function SortByFilter() {
  const { control } = useFormContext<MediaFormFields>();
  const { t } = useTranslation();

  return (
    <Controller
      name="sortOrder"
      control={control}
      render={({ field: { value, onChange } }) => (
        <div className={classes.sortByFilter}>
          <span className={classes.label}>{t("media.library.sortBy")}</span>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={value}
            onChange={onChange}
            size="small"
            sx={{
              borderRadius: "8px",
            }}
          >
            <MenuItem value={"asc"}>{t("media.library.sortAlphabeticalAsc")}</MenuItem>
            <MenuItem value={"desc"}>{t("media.library.sortAlphabeticalDesc")}</MenuItem>
          </Select>
        </div>
      )}
    />
  );
}
